<template>
    <div class="right">
        <div class="top" style="background-color:#f0f0f0">
            <el-input style="width:50%;margin-left:5%" placeholder="请输入名称搜索" v-model="name"></el-input>
            <el-button style="height:70%;margin-left:3%" type="primary" @click="search">搜索</el-button>
           <el-button style="height:70%" type="danger" @click="reload">重置</el-button>
        </div>
        <div class="content">
            <ul v-for="(v,i) in dataList" :key='i' style="width:100%;height:90px;" @click="pop(v)">
                <li style="width:95%;height:90%;background-color:#fff;margin-top:2%;margin-left:5%;" class="item">
                    <div class="c_left"> 
                         <img style="width:100%;height:75px;" :src="'https://tour.i-lianjiang.cn/lianjiang_web_a'+v.coverImageUrl" alt="">
                    </div>
                   <div class="c_right">
                       <span>{{v.title}}</span>
                       <span>{{v.summary | summary}}</span>
                       <span style="display:flex;justify-content:space-between;align-items:center">价格:{{v.price}} <el-button type="primary" size="mini" @click="addXc(v)">添加行程</el-button></span>
                   </div>
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    data(){
        return{
            name:null
        }
    },
    props:{
       dataList:{
				type:Array,
				default:()=>{
					return []
				}
			}
    },
    filters:{
        summary(v){
            if(v.length>20){
                return v.slice(0,20)+'...'
            }else if(v==''){
                return '暂无简介'
            }else{
                return v
            }
        }
    },
    methods:{
        addXc(v){
            this.$emit('xcgh',v)
        },
        pop(v){
            this.$emit('popup',v)
        },
        search(){
            this.$emit('search',this.name)
        },
        reload(){
            this.name=null
            this.$emit('reload',this.name)
        }
    }
}
</script>

<style lang="less" scoped>
    .right{
        position: absolute;
        right: 0;
        top: 0;
        width: 30%;
        height: 100%;
        background-color: #fff;
        display: subgrid;
        display: flex;
        flex-direction: column;
        align-items: center;
        .top{
            width: 95%;
            height: 55px;
            display: flex;
            align-items: center;
        }
        .content{
            width:95%;
            height:90%;
            display: flex;
            flex-direction: column; 
            overflow:auto;
            background-color: #f0f0f0;
        .item{
            display: flex;
            flex-direction: row;
            .c_left{
                width:25%
            }
            .c_right{
                width:65%;
                display:flex;
                flex-direction: column;
                margin-left:5%;
                justify-content: space-around;
            }
        }
        }
    }
</style>